// Base de questions/réponses du chatbot d'assistance CCCA.
// keywords sert au matching des questions tapées librement par l'internaute.
const faqData = [
  {
    id: "adhesion",
    question: "Comment devenir membre de la CCCA ?",
    keywords: ["membre", "adherer", "adhesion", "inscription", "rejoindre", "devenir"],
    answer:
      "Pour devenir membre de la CCCA, rendez-vous sur notre page \"Devenir membre\" et remplissez le formulaire d'adhésion et payez votre Membership. Notre équipe vous recontactera pour finaliser votre inscription.",
    link: { to: "/Devenir-membre", label: "Devenir membre" },
  },
  {
    id: "programmes",
    question: "Quels programmes d'accompagnement proposez-vous ?",
    keywords: ["programme", "pygmalion", "catapulte", "excelle", "impulse", "intensif", "propulse", "rayonne", "accompagnement"],
    answer:
      "Nous proposons plusieurs programmes d'accompagnement (Pygmalion, Catapulte, ExcElle, Impulse, Intensif, Propulse, Rayonne) destinés aux entrepreneurs souhaitant développer leurs activités entre le Canada et l'Afrique.",
    link: { to: "/Formations", label: "Voir les programmes" },
  },
  {
    id: "incubation",
    question: "Proposez-vous un programme d'incubation ?",
    keywords: ["incubation", "incubateur", "startup", "porteur de projet"],
    answer:
      "Oui, la CCCA propose un programme d'incubation pour accompagner les porteurs de projets dans le développement de leur entreprise.",
    link: { to: "/Incubation", label: "En savoir plus sur l'incubation" },
  },
  {
    id: "evenements",
    question: "Où puis-je voir vos prochains événements ?",
    keywords: ["evenement", "event", "agenda", "business connect", "salon", "conference"],
    answer:
      "Tous nos événements à venir (conférences, salons, Business Connect...) sont listés sur la page Événements du site.",
    link: { to: "/Evenements", label: "Voir les événements" },
  },
  {
    id: "actualites",
    question: "Où trouver vos actualités ?",
    keywords: ["actualite", "news", "article", "presse"],
    answer:
      "Retrouvez toutes nos dernières actualités et communiqués sur la page Actualités.",
    link: { to: "/Actualites", label: "Voir les actualités" },
  },
  {
    id: "bureaux",
    question: "Où sont situés vos bureaux en Afrique ?",
    keywords: ["bureau", "afrique", "zone", "pays", "represent"],
    answer:
      "La CCCA dispose de bureaux et de représentations dans plusieurs pays d'Afrique. Vous pouvez consulter la liste complète par zone géographique sur la page Bureau Afrique.",
    link: { to: "/Bureau", label: "Voir les bureaux en Afrique" },
  },
  {
    id: "services",
    question: "Quels services offrez-vous aux entreprises ?",
    keywords: ["service", "accompagnement entreprise", "prestation"],
    answer:
      "Nous offrons plusieurs services aux entreprises et entrepreneurs : mise en réseau, accompagnement, formation, mise en relation d'affaires entre le Canada et l'Afrique.",
    link: { to: "/Services", label: "Voir nos services" },
  },
  {
    id: "mission",
    question: "Quelle est la mission de la CCCA ?",
    keywords: ["mission", "objectif", "qui etes vous", "chambre de commerce"],
    answer:
      "La Chambre de Commerce Canada-Afrique (CCCA) a pour mission de développer les échanges économiques et commerciaux entre le Canada et l'Afrique, en accompagnant les entrepreneurs des deux continents.",
    link: { to: "/Mission", label: "Découvrir notre mission" },
  },
  {
    id: "contact",
    question: "Comment vous contacter ?",
    keywords: ["contact", "telephone", "email", "mail", "joindre", "adresse"],
    answer:
      "Vous pouvez nous écrire à ca@cc-ca.ca ou nous appeler au +1 (438) 388-3606. Vous pouvez aussi utiliser notre formulaire de contact.",
    link: { to: "/Apropos-de-nous/Contacts", label: "Formulaire de contact" },
  },
  {
    id: "apropos",
    question: "Qui a fondé la CCCA et qui en assure la direction ?",
    keywords: [
      "direction", "conseil d'administration", "equipe", "dirigeant",
      "president", "vice president", "fondee", "fondation", "creee",
      "creation", "histoire", "fondateur", "ngaketcha", "levesque", "stoltz", "finance",
    ],
    answer:
      "La CCCA a été fondée en septembre 2024 par le Dr Armand Ngaketcha, qui en est l'actuel président. Le vice-président est M. Christian Levesque, et la responsable des finances est Mme Nathalie Stoltz. Retrouvez tous les détails de notre gouvernance dans la rubrique À propos de nous.",
    link: { to: "/Apropos-de-nous/Présentation", label: "À propos de nous" },
  },
];

export const fallbackAnswer = {
  answer:
    "Je n'ai pas de réponse toute prête pour cette question. Vous pouvez la poser directement à notre équipe à info@cc-ca.ca ou via notre formulaire de contact.",
  link: { to: "/Apropos-de-nous/Contacts", label: "Formulaire de contact" },
  email: "info@cc-ca.ca",
  isFallback: true,
};

export function findBestMatch(userText) {
  const normalized = userText
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");

  let best = null;
  let bestScore = 0;

  for (const item of faqData) {
    let score = 0;
    for (const keyword of item.keywords) {
      if (normalized.includes(keyword)) score += 1;
    }
    if (score > bestScore) {
      bestScore = score;
      best = item;
    }
  }

  return bestScore > 0 ? best : null;
}

export default faqData;
